import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Notifications } from '@models/notifications/Notifications.interface';
import { Logger } from '@services/logging.service';
import { Subscription } from 'rxjs';
import { NotificationPosition } from './enums/NotificationPosition.enum';
import { NotificationService } from './notification.service';
import { NotificationToast } from './toast/notification-toast.model';
import { NotificationEvent } from './types/event.type';




@Component({
  selector: 'xm-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class XmNotificationComponent implements OnInit, OnDestroy {
  /**
   * Toasts array
   */
  notifications: Notifications;
  /**
   * Toasts emitter
   */
  emitter: Subscription;
  /**
   * Helper for slice pipe (maxOnScreen)
   */
  dockSizeA: number;
  /**
   * Helper for slice pipe (maxOnScreen)
   */
  dockSizeB: number | undefined;
  /**
   * Helper for slice pipe (maxAtPosition)
   */
  blockSizeA: number;
  /**
   * Helper for slice pipe (maxAtPosition)
   */
  blockSizeB: number | undefined;
  /**
   * Backdrop Opacity
   */
  backdrop: number | undefined = -1;
  /**
   * How many toasts with backdrop in current queue
   */
  withBackdrop: NotificationToast[];

  constructor(private service: NotificationService, private cdr: ChangeDetectorRef) { }

  /**
   * Init base options. Subscribe to options, lifecycle change
   */
  ngOnInit(): void {
    this.emitter = this.service.emitter.subscribe(
      (toasts: NotificationToast[]) => {

        if (this.service.config.global.newOnTop) {
          // @ts-ignore look into refactor on notifications
          this.dockSizeA = -this.service.config.global.maxOnScreen;
          this.dockSizeB = undefined;
          // @ts-ignore look into refactor on notifications
          this.blockSizeA = -this.service.config.global.maxAtPosition;
          this.blockSizeB = undefined;
          // @ts-ignore look into refactor on notifications
          this.withBackdrop = toasts.filter(toast => toast.config.backdrop >= 0);
        } else {
          this.dockSizeA = 0;
          this.dockSizeB = this.service.config.global.maxOnScreen;
          this.blockSizeA = 0;
          this.blockSizeB = this.service.config.global.maxAtPosition;
          // @ts-ignore look into refactor on notifications
          this.withBackdrop = toasts.filter(toast => toast.config.backdrop >= 0).reverse();
        }
        this.notifications = this.splitToasts(toasts.slice(this.dockSizeA, this.dockSizeB));
        this.stateChanged('mounted');
      }
    );

  }

  // TODO: fix backdrop if more than one toast called in a row
  /**
   * Changes the backdrop opacity
   * @param {NotificationEvent} event
   */
  stateChanged(event: NotificationEvent) {
    if (this.backdrop === undefined) {
      Logger.warn('notification.component stateChanged() this.backdrop undefined');
      return;
    }

    if (!this.withBackdrop.length) {
      if (this.backdrop >= 0) {
        this.backdrop = -1;
      }
      return;
    }
    switch (event) {
      case 'mounted':
        if (this.backdrop < 0) {
          this.backdrop = 0;
        }
        break;
      case 'beforeShow':
        this.backdrop = this.withBackdrop[this.withBackdrop.length - 1].config.backdrop;
        break;
      case 'beforeHide':
        if (this.withBackdrop.length === 1) {
          this.backdrop = 0;
        }
        break;
      case 'hidden':
        if (this.withBackdrop.length === 1) {
          this.backdrop = -1;
        }
        break;
    }

  }

  /**
   * Split toasts toasts into different objects
   * @param {NotificationToast[]} toasts
   * @returns {Notifications}
   */
  splitToasts(toasts: NotificationToast[]): Notifications {
    const result: Notifications = {};

    for (const property in NotificationPosition) {
      if (NotificationPosition.hasOwnProperty(property)) {
        (result as any)[(NotificationPosition as any)[property]] = [];
      }
    }

    toasts.forEach((toast: NotificationToast) => {
      (result as any)[toast.config.position as string].push(toast);
    });

    return result;
  }

  checkBackdrop(backdrop: number) {
    return backdrop >= 0;
  }

  /**
   * Unsubscribe subscriptions
   */
  ngOnDestroy() {
    this.emitter.unsubscribe();
  }

}
